import React, { ReactNode } from "react";
import {
  UserPlus,
  Building2,
  CalendarDays,
  Clock,
  UsersRound,
  Copy,
  Pencil,
  Hourglass,
  Trash2,
  ClipboardList,
  Mail,
  PersonStanding,
  Lock,
  LockOpen,
} from "lucide-react";

const ICON_SIZE = 16;

export const CARD_ACTION_ICON_MAP: Record<string, ReactNode> = {
  enroll: <UserPlus size={ICON_SIZE} />,
  "associate-initiatives": <Building2 size={ICON_SIZE} />,
  "see-editions": <CalendarDays size={ICON_SIZE} />,
  "enrolled-users": <UserPlus size={ICON_SIZE} />,
  "pre-enrolled-users": <Building2 size={ICON_SIZE} />,
  "waiting-users": <Clock size={ICON_SIZE} />,
  "enrolled-groups": <UsersRound size={ICON_SIZE} />,
  duplicate: <Copy size={ICON_SIZE} />,
  edit: <Pencil size={ICON_SIZE} />,
  suspend: <Hourglass size={ICON_SIZE} />,
  delete: <Trash2 size={ICON_SIZE} />,
  "view-lo": <ClipboardList size={ICON_SIZE} />,
  "welcome-mail": <Mail size={ICON_SIZE} />,
  impersonate: <PersonStanding size={ICON_SIZE} />,
  block: <Lock size={ICON_SIZE} />,
  unblock: <LockOpen size={ICON_SIZE} />,
};
